.container {}
.numberField {
  display: block;

  input {
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 6px;
    margin-bottom: 6px;
    width: 4rem;
  }

  .scenarioSelect {
    margin-left: 12px;
  }
}

.actionButton {
  margin: 16px;
}

.simulationCanvas {
  display: block;
  border: 2px solid var(--border-color);
  margin: 16px;
  background: var(--canvas-background);
}

.results {
  margin-left: 16px;
}

.result {
  display: inline-block;
  min-width: 8rem;
  margin: 6px;
}